export default __webpack_public_path__ + "static/media/green-dot.6c8069e8.svg";